import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PreAdesaoModel } from '../models/pre-adesao.model';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})
export class PreAdesaoService {

  constructor(private http: HttpClient, private util: UtilService) {

  }

  public salvar(dados: PreAdesaoModel){

    return this.http
                .post(`${environment.apiURL}/Aberto/PreAdessao/Salvar`, this.util.flattenObject(dados));
  }

  public verificaSeTemAdesao(cpf: string, recaptchaV2Token: string, recaptchaV3Token: string){

    return this.http
               .post(`${environment.apiURL}/Aberto/PreAdessao/VerificaSeTemAdesao`, {cpf: cpf, recaptchaV2Token: recaptchaV2Token, recaptchaV3Token: recaptchaV3Token})
  }

}
